import "./index.css";

const Spinner = () => (
    <div className="flex items-center mx-auto space-x-4">
        <span className="loading"></span>
    </div>
);

export { Spinner };
